@if (label) {
  <label class="form-label">{{ label }}</label>
}
<div class="d-flex align-items-center">
  <div class="form-check form-switch me-1">
    <input class="form-check-input" type="checkbox" [(ngModel)]="enabled" [ngModelOptions]="{standalone: true}" (ngModelChange)="onChange()">
  </div>
  <input class="form-control form-control-color" [(ngModel)]="color" [ngModelOptions]="{standalone: true}" (ngModelChange)="onChange()" type="color"
    placeholder="Color" [disabled]="!enabled" [style.opacity]="getPreviewOpacity()">
  @if (opacityEnabled) {
    <input class="form-range form-control-color-alpha ms-1" type="range" min="0" max="100" value="100"
      [(ngModel)]="opacity" [ngModelOptions]="{standalone: true}" (ngModelChange)="onChange()" [disabled]="!enabled">
  }
</div>
